<template>
    <div class="settlement_container">
        <!-- 搜索区域 -->
        <global-tag>
            <span slot="title">服务商信息</span>
            <div class="search" slot="search">
                <el-form label-width="100px">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="建设单位：">
                                <el-input
                                    v-model="constructUnit"
                                    placeholder="请输入建设单位"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="负责人：">
                                <el-input
                                    v-model="leader"
                                    placeholder="请输入负责人"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5" :offset="1">
                            <el-form-item label="负责人电话：">
                                <el-input
                                    v-model="phone"
                                    placeholder="请输入负责人电话"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" :offset="1">
                            <el-button
                                type="primary"
                                class="searchBtns"
                                @click="search"
                                >搜索</el-button
                            >
                        </el-col>
                        <el-col :span="4">
                            <el-button
                                type="info"
                                class="resetReach"
                                @click="reset"
                                >重置</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group" style="margin: 15px 0">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        class="openBtns"
                        @click="handleTableForm('新增')"
                        >新增</el-button
                    >
                </el-button-group>
            </div>
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        class="dropRests"
                        icon="el-icon-refresh"
                        @click="Reset1"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        class="dropdown1"
                        trigger="click"
                        :hide-on-click="false"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox
                                    ><br />
                                    <el-checkbox label="建设单位"></el-checkbox
                                    ><br />
                                    <el-checkbox label="负责人"></el-checkbox
                                    ><br />
                                    <el-checkbox
                                        label="负责人电话"
                                    ></el-checkbox
                                    ><br />
                                    <el-checkbox label="创建人"></el-checkbox
                                    ><br />

                                    <el-checkbox label="单位地址"></el-checkbox
                                    ><br />
                                    <el-checkbox label="操作"></el-checkbox>
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- 页面表格 -->
        <div class="table_container" style="margin-top: 10px">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    width="80"
                    align="center"
                    label="序号"
                    type="index"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="建设单位"
                    prop="constructUnit"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '建设单位'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="负责人"
                    prop="leader"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '负责人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="负责人电话"
                    prop="phone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '负责人电话'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="单位地址"
                    prop="address"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '单位地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="createPersonName"
                    min-width="60px"
                    label="创建人"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    width="180"
                    align="center"
                    label="操作"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="查看"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/detail.png"
                                style="cursor: pointer"
                                @click="handleTableForm('查看', scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip
                            effect="dark"
                            content="编辑"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_edit.png"
                                @click="handleTableForm('编辑', scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                        <el-tooltip
                            effect="dark"
                            content="服务人员"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/examine.png"
                                @click="handleTableForm1('服务人员', scope.row)"
                                style="
                                    width: 18px;
                                    margin-left: 12px;
                                    cursor: pointer;
                                "
                            />
                        </el-tooltip>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="删除"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_delete.png"
                                alt=""
                                style="margin-left: 12px; cursor: pointer"
                                @click="deleteId(scope.row)"
                            />
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="pageNo"
                @size-change="handletableSize"
                @current-change="handleTableChange"
            ></el-pagination>
        </div>
        <!-- 表格表单弹窗 -->
        <el-dialog
            :title="dialogVisibleTitle"
            :visible.sync="dialogVisible"
            width="60%"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    label-width="120px"
                    :model="formData"
                    ref="addformRef"
                    :disabled="dialogVisibleTitle == '查看'"
                    :rules="formDataRulse"
                >
                    <el-form-item label="建设单位：" prop="constructUnit">
                        <el-input
                            v-model="formData.constructUnit"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="负责人：" prop="leader">
                        <el-input
                            v-model="formData.leader"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="负责人电话：" prop="phone">
                        <el-input
                            v-model="formData.phone"
                            placeholder="请输入"
                            @blur="phoneChange"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="所属机构:" prop="dataId">
                        <el-input
                            v-if="formData.dataName"
                            v-model="formData.dataName"
                            disabled
                        ></el-input>
                        <el-cascader
                            :options="orgList"
                            v-model="formData.dataId"
                            style="width: 100%"
                            ref="tree"
                            :props="{
                                checkStrictly: true,
                                emitPath: false,
                                label: 'label',
                                value: 'orgId',
                            }"
                            v-else
                        ></el-cascader>
                    </el-form-item>

                    <el-form-item label="单位地址：">
                        <el-row :gutter="12" style="display: flex">
                            <el-col :span="4">
                                <el-form-item>
                                    <el-select
                                        v-model="formData.shengId"
                                        :disabled="
                                            normalInfo.orgLevel == 1 ||
                                            normalInfo.orgLevel == 2 ||
                                            normalInfo.orgLevel == 3 ||
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5
                                        "
                                        placeholder="请选择省"
                                        @change="handleProvince"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(
                                                item, index
                                            ) in provinceList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-select
                                    v-model="formData.shiId"
                                    :disabled="
                                        normalInfo.orgLevel == 2 ||
                                        normalInfo.orgLevel == 3 ||
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5
                                    "
                                    placeholder="请选择市"
                                    @change="handleCity"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in cityList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="5">
                                <el-select
                                    v-model="formData.quId"
                                    :disabled="
                                        normalInfo.orgLevel == 3 ||
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5
                                    "
                                    placeholder="请选择区"
                                    @change="handleArea"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in areaList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="5">
                                <el-select
                                    v-model="formData.streetId"
                                    :disabled="
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5
                                    "
                                    placeholder="请选择街道"
                                    @change="streetChange"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in streetList"
                                        :key="index"
                                        :label="item.addName"
                                        :value="item.addCode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="5">
                                <el-select
                                    v-model="formData.shequId"
                                    :disabled="normalInfo.orgLevel == 5"
                                    placeholder="请选择请选择社区"
                                    @change="handleCommunityChange"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in communityList"
                                        :key="index"
                                        :label="item.address"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <!-- <el-select
                v-model="formData.address1"
                placeholder="请选择"
                style="width: 31%; margin-left: 1%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="formData.address2"
                placeholder="请选择"
                style="width: 31%; margin-left: 1%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="formData.address3"
                placeholder="请选择"
                style="width: 31%; margin-left: 1%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
                        </el-row>
                        <el-row>
                            <input
                                v-model.trim="formData.address"
                                :disabled="dialogVisibleTitle == '查看'"
                                id="tipinput"
                                class="el-input__inner"
                                :class="
                                    dialogVisibleTitle == '查看'
                                        ? 'innerCur'
                                        : ''
                                "
                                @focus="getMap('tipinput')"
                                placeholder="请输入关键字"
                                autocomplete="off"
                            />
                        </el-row>
                        <!-- <el-row style="margin-top: 20px">
              <el-input
                v-model="formData.address"
                placeholder="请输入"
              ></el-input> -->
                        <el-row style="margin-top: 20px">
                            <div
                                class="mapright"
                                id="container"
                                style="width: 100%; height: 300px"
                            ></div>
                        </el-row>
                    </el-form-item>
                </el-form>
            </div>
            <span
                slot="footer"
                class="dialog-footer"
                v-if="dialogVisibleTitle != '查看'"
            >
                <el-button type="primary" @click="save">确 定</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 人员列表 -->
        <el-dialog
            :title="dialogVisibleTitle1"
            :visible.sync="dialogVisible1"
            width="40%"
            class="dialog_container"
            @close="dialogVisibleClone1"
        >
            <div class="table_title">
                <div class="btn_group" style="margin: 5px 0">
                    <el-button-group>
                        <el-button
                            type="success"
                            icon="iconfont icon-xinzeng"
                            @click="handleTableForm2('新增')"
                            >新增</el-button
                        >
                    </el-button-group>
                </div>
            </div>
            <div class="dialog_content">
                <el-table
                    :data="tableData1"
                    tooltip-effect="dark"
                    style="width: 100%"
                    height="200px"
                    :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
                    border
                >
                    <el-table-column
                        width="80"
                        align="center"
                        label="序号"
                        type="index"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        label="姓名"
                        prop="name"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        label="联系方式"
                        prop="phone"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        label="身份证号"
                        prop="idCode"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <!-- <el-table-column width="180" align="center" label="操作">
                        <template slot-scope="scope"> -->
                    <!-- <el-tooltip
                                class="item"
                                effect="dark"
                                content="查看"
                                placement="top-start"
                            >
                                <img
                                    src="../assets/img/detail.png"
                                    style="cursor: pointer"
                                    @click="handleTableForm2('查看', scope.row)"
                                />
                            </el-tooltip>
                            <el-tooltip
                                effect="dark"
                                content="编辑"
                                placement="top-start"
                            >
                                <img
                                    src="../assets/img/table_edit.png"
                                    @click="handleTableForm2('编辑', scope.row)"
                                    style="margin-left: 12px; cursor: pointer"
                                />
                            </el-tooltip> -->
                    <!-- <el-tooltip
                                class="item"
                                effect="dark"
                                content="删除"
                                placement="top-start"
                            >
                                <img
                                    src="../assets/img/table_delete.png"
                                    alt=""
                                    style="margin-left: 12px; cursor: pointer"
                                    @click="deletePersonId(scope.row)"
                                />
                            </el-tooltip>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div class="pagination_container">
                    <el-pagination
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tableDataTotal"
                        :page-size="tableDataPageSize"
                        :current-page.sync="tableDataPageNo"
                        @size-change="handleTableDataPageSize"
                        @current-change="handleTableDataChange"
                    ></el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save2">确 定</el-button>
                <el-button @click="clear2">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 人员列表新增查看 -->
        <el-dialog
            :title="dialogVisibleTitle2"
            :visible.sync="dialogVisible2"
            width="40%"
            class="dialog_container"
            @close="dialogVisibleClone2"
        >
            <el-table
                ref="multiapleTable"
                :data="ServiceList"
                border
                style="width: 100%"
                @selection-change="handleSelectionChange"
                :row-key="getRowKey"
            >
                <el-table-column
                    type="selection"
                    :reserve-selection="true"
                    width="55"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="personName"
                    label="姓名"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="personPhone"
                    label="联系方式"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="personIdentity"
                    label="身份证号码"
                >
                </el-table-column>
            </el-table>
            <div class="pagination_container">
                <el-pagination
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData1Total"
                    :page-size="tableData1PageSize"
                    :current-page.sync="tableData1PageNo"
                    @size-change="handleTableData1PageSize"
                    @current-change="handleTableData1Change"
                ></el-pagination>
            </div>
            <span
                slot="footer"
                class="dialog-footer"
                v-if="dialogVisibleTitle2 != '查看'"
            >
                <el-button type="primary" @click="save1">确 定</el-button>
                <el-button @click="clear1">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import common from "../../../utils/common.js"
import globalTag from "../components/globalTag"
import baseURL from "@/api/baseURL"
import { chekPhone, chekCode } from "../util"
export default {
    name: "service",
    data() {
        // var chekPhone = (rule, value, callback) => {
        //     let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
        //     if (!validatePhone.test(value)) {
        //         return callback(new Error("手机号格式错误"))
        //     }
        //     callback()
        // }
        return {
            formDataRulse: {
                constructUnit: [
                    {
                        required: true,
                        message: "请输入建设单位",
                        trigger: "blur",
                    },
                ],
                leader: [
                    {
                        required: true,
                        message: "请输入负责人姓名",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入负责人电话",
                        trigger: "blur",
                    },
                    // { validator: chekPhone, trigger: "blur" },
                ],
            },
            defaultProps: {
                children: "children",
                label: "label",
            },
            orgLevels: "",
            isdisabled: false,
            orgList: [],
            arrOrgList: [],
            tableDataPageNo: 0,
            tableDataPageSize: 10,
            tableData1PageNo: 0,
            tableData1PageSize: 10,
            tableDataTotal: 0,
            tableData1Total: 0,
            visVisible: false,
            title: "",
            constructUnit: "", //姓名
            leader: "", //负责人
            phone: "", //负责人电话
            tableData: [],
            formData: {
                //table表单
                constructUnit: "", //建设单位
                leader: "", //负责人
                phone: "", //负责人手机
                shengId: "",
                shiId: "",
                quId: "",
                streetId: "",
                shequId: "",
                address: "",
                orgId: "",
                orgName: "",
            },
            dataIds: "",
            tempTableChekbox: [
                "序号",
                "建设单位",
                "负责人",
                "负责人电话",
                "单位地址",
                "创建人",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "建设单位",
                "负责人",
                "负责人电话",
                "单位地址",
                "创建人",
                "操作",
            ],

            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title

            dialogVisible1: false, //人员列表
            dialogVisibleTitle1: "", //人员列表

            dialogVisible2: false, //人员列表查看新增
            dialogVisibleTitle2: "", //人员列表查看新增
            options: [
                {
                    value: "0",
                    label: "县",
                },
                {
                    value: "1",
                    label: "市",
                },
                {
                    value: "2",
                    label: "省",
                },
            ],
            pageSize: 10,
            pageNo: 1,
            total: 0,
            tableData1: [],
            ServiceList: [],
            formData1: {
                name: "",
                phone: "",
                idCode: "",
            },
            workId: "", //保存公司id
            listid: "", //列表id
            provinceList: [], //省列表
            cityList: [], //市列表
            areaList: [], //区列表
            streetList: [], //街道列表
            communityList: [], //社区列表
            myMap: null, //地图
            polygons: [],
            polygon: [],
            isMap: true,
            normalInfo: {},
            cneterList: [],
            serviceProviderPersonIds: [],
        }
    },
    components: {
        globalTag,
    },
    inject: ["reload"], //注入
    methods: {
        phoneChange(val) {
            let validatePhone = /^1[0-9]{10}$/
            if (!validatePhone.test(this.formData.phone)) {
                this.$message.error("手机号格式错误")
            } else {
                this.$http
                    .request({
                        url: "/jjyl/admin/serviceProvider/info/findProviderList",
                        method: "POST",
                        data: {
                            id: this.listid,
                            phone: this.formData.phone,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            //this.$message(res.message)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
            }
        },
        handleSelectionChange(val) {
            this.cneterList = val
        },
        getRowKey(row) {
            return row.id
        },
        getServiceList() {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceProviderPerson/info/findList",
                    method: "POST",
                    data: {
                        pageNo: this.tableData1PageNo,
                        pageSize: this.tableData1PageSize,
                        dataId: this.dataIds,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content != null) {
                            this.ServiceList = res.content.list
                            this.tableData1Total = res.content.count
                            this.$nextTick(() => {
                                this.tableData1.forEach((item) => {
                                    for (let i in this.ServiceList) {
                                        if (
                                            item.idCode ==
                                            this.ServiceList[i].idCode
                                        ) {
                                            this.$refs.multiapleTable.toggleRowSelection(
                                                this.ServiceList[i],
                                                true
                                            )
                                        }
                                    }
                                })
                            })
                        }
                    }
                })
        },
        // getchangeList() {
        //     this.$http
        //         .request({
        //             url: "/ypt/admin/serviceStaff/info/findList",
        //             method: "POST",
        //             data: {
        //                 pageNo: 1,
        //                 pageSize: 999,
        //             },
        //         })
        //         .then((res) => {
        //             console.log(res)
        //             if (res.code == 200) {
        //                 if (res.content != null) {
        //                     this.list = res.content.list
        //                 }
        //             }
        //         })
        // },
        querySearchAsync(queryString, cb) {
            let result = this.list.filter((item) => {
                if (item.personName.indexOf(queryString) > -1) {
                    return true
                }
            })
            cb(result)
        },
        //监控姓名是否为空
        clearForm(val) {
            if (val.length === 0) {
                this.formData1 = {}
            }
        },
        async handleSelect(item) {
            let self = this
            this.$set(this.formData1, "name", item.personName)
            this.$set(this.formData1, "phone", item.personPhone)
            this.$set(this.formData1, "idCode", item.personIdentity)
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: {
                        isValid: 1,
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if (res.code == 200 && res.content) {
                        let item = this.chbehavior(
                            res.content,
                            this.$store.state.info.orgId
                        )
                        this.orgList.push(item)
                        // console.log(this.orgList)
                    }
                })
        },
        chbehavior(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        //获取组织机构的名称
        setDataName(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a.label
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        // 输入地址
        getMap(input) {
            const self = this
            const autoOptions = {
                city: this.formData.quId,
                citylimit: true,
                input: input,
            }
            // alert(input)
            const auto = new AMap.Autocomplete(autoOptions)
            //构造地点查询类
            AMap.event.addListener(auto, "select", (e) => {
                self.formData.address = e.poi.name
                self.formData.longitude = e.poi.location.lng
                self.formData.latitude = e.poi.location.lat
                self.potintMap()
            })
        },
        async changeFirst() {
            if (this.normalInfo.provinceId == 0) {
                this.normalInfo.provinceId = ""
            } else {
                this.normalInfo.provinceId = String(this.normalInfo.provinceId)
                let cityList = await this.getDistrict(
                    this.normalInfo.provinceId
                )
                this.cityList = cityList.districtList
            }
            if (this.normalInfo.cityId) {
                this.normalInfo.cityId = String(this.normalInfo.cityId)
                let areaList = await this.getDistrict(this.normalInfo.cityId)
                this.areaList = areaList.districtList
            } else {
                this.normalInfo.cityId = ""
            }
            if (this.normalInfo.areaId) {
                this.normalInfo.areaId = String(this.normalInfo.areaId)
                let streetList = await this.getStreetList(
                    this.normalInfo.areaId
                )
                this.streetList = streetList
            } else {
                this.normalInfo.areaId = ""
            }
            if (this.normalInfo.streetId) {
                this.normalInfo.streetId = String(this.normalInfo.streetId)
                let communityList = await this.getCommityList(
                    this.normalInfo.streetId
                )
                this.communityList = communityList
            } else {
                this.normalInfo.streetId = ""
            }
            if (
                this.normalInfo.orgLevel == 1 ||
                this.normalInfo.orgLevel == 0
            ) {
                this.provinceList.forEach((item) => {
                    if (item.adcode == this.normalInfo.provinceId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 2) {
                this.cityList.forEach((item) => {
                    if (item.adcode == this.normalInfo.cityId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 3) {
                this.areaList.forEach((item) => {
                    if (item.adcode == this.normalInfo.areaId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (
                this.normalInfo.orgLevel == 4 ||
                this.normalInfo.orgLevel == 5
            ) {
                this.streetList.forEach((item, index) => {
                    if (item.addCode == this.normalInfo.streetId) {
                        // this.formData.latitude = item.center.lat
                        this.formData.latitude = item.latitude
                        this.formData.longitude = item.longitude
                    }
                })
            }

            if (this.normalInfo.shequId) {
                this.normalInfo.shequId = Number(this.normalInfo.shequId)
            } else {
                this.normalInfo.shequId = ""
            }

            this.formData.shengId = this.normalInfo.provinceId
            this.formData.shiId = this.normalInfo.cityId
            this.formData.quId = this.normalInfo.areaId
            this.formData.streetId = this.normalInfo.streetId
            this.formData.shequId = this.normalInfo.shequId
            this.loadmap("container")
            setTimeout(() => {
                this.potintMap()
            }, 500)
            this.$forceUpdate()
        },
        // 打点
        potintMap() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {}
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(self.formData.longitude),
                    Number(self.formData.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        // 获取省市区
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {}

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                        if (bounds) {
                            try {
                                self.myMap.remove(self.polygons)
                            } catch (error) {}
                            self.polygons = []
                            for (let i = 0, l = bounds.length; i < l; i++) {
                                self.polygon = new AMap.Polygon({
                                    map: self.myMap,
                                    strokeWeight: 1,
                                    strokeColor: "#0091ea",
                                    fillColor: "#80d8ff",
                                    fillOpacity: 0.4,
                                    path: bounds[i],
                                })
                                self.polygons.push(self.polygon)
                                if (!params) {
                                    self.polygon.on("click", function (e) {
                                        let lnglat = e.lnglat
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition(lnglat)
                                        geocoder.getAddress(
                                            lnglat,
                                            function (status, result) {
                                                if (
                                                    status === "complete" &&
                                                    result.regeocode
                                                ) {
                                                    var address =
                                                        result.regeocode
                                                            .formattedAddress
                                                    self.formData.address =
                                                        address
                                                    self.formData.addressLng =
                                                        lnglat.lng
                                                    self.formData.addressLat =
                                                        lnglat.lat
                                                } else {
                                                    console.error(
                                                        "根据经纬度查询地址失败"
                                                    )
                                                }
                                            }
                                        )
                                    })
                                    self.myMap.add(self.polygons)
                                    self.myMap.setFitView() //地图自适应
                                } else {
                                    if (
                                        params.addressLng &&
                                        params.addressLat
                                    ) {
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition([
                                            params.addressLng,
                                            params.addressLat,
                                        ])
                                        self.myMap.setFitView(self.marker)
                                        self.myMap.setZoom(11)
                                    }
                                }
                            }
                        }
                    }
                })
            }).catch((err) => {})
        },
        //街道地址发生变化
        async streetChange(val) {
            this.formData.shequId = ""
            let communityList = await this.getCommityList(val)
            this.communityList = communityList
        },
        //街道地址列表
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {})
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            jiedaoId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {})
        },
        handleCommunityChange(val) {
            this.$nextTick(() => {
                this.$forceUpdate()
                // this.joinAddress()
            })
        },
        // 页面刷新
        Reset() {
            this.reload()
        },
        // 保留条件刷新
        Reset1() {
            this.showList(true)
            this.tableChekbox = [
                "序号",
                "建设单位",
                "负责人",
                "负责人电话",
                "单位地址",
                "操作",
            ]
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //加载地图
        loadmap() {
            let self = this
            return new Promise((resolve, reject) => {
                self.myMap = new AMap.Map("container", {
                    resizeEnable: true,
                    zoom: 18,
                })
                resolve()
            })
        },

        //获取省级
        async getProvince() {
            this.provinceLis = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.formData.shiId = ""
            this.formData.quId = ""
            let city = await this.getDistrict(val)
            this.cityList = city.districtList
        },
        //市级地址发生改变
        async handleCity(val) {
            this.formData.quId = ""
            this.areaList = []
            this.streetList = []
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.formData.jiedaoId = ""
            this.formData.shequId = ""
            this.streetList = []
            // val = val.replace(/.$/, "");
            let streetList = await this.getStreetList(val)
            this.streetList = streetList
        },
        //处理table表格表单
        handleTableForm(title, date) {
            let self = this
            this.dialogVisibleTitle = title
            this.dialogVisible = true
            this.isdisabled = false
            if (title != "新增") {
                this.listid = date.id
            }
            setTimeout(async () => {
                await self.$nextTick(() => self.loadmap())
            }, 30)
            switch (title) {
                case "新增":
                    this.formData.dataName = ""
                    this.formData.dataId = ""
                    this.changeFirst()
                    break
                case "查看":
                    this.look(date)
                    break
                case "编辑":
                    this.look(date)
                    break
                default:
                    break
            }
        },

        //人员列表
        handleTableForm1(title, date) {
            this.dialogVisibleTitle1 = title
            this.dialogVisible1 = true
            this.workId = date.id
            this.dataIds = date.dataId
            this.look2(date)
            switch (title) {
                case "新增":
                    break
                case "查看":
                    break
                default:
                    break
            }
        },

        look3(date) {
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            request({
                url: "/jjyl/admin/serviceProviderPerson/info/getById",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code == 200) {
                    this.formData1 = res.content
                }
            })
        },
        //人员列表新增查看
        async handleTableForm2(title, date) {
            this.dialogVisibleTitle2 = title
            this.dialogVisible2 = true
            this.$nextTick(() => {
                this.$refs.multiapleTable.clearSelection()
                this.tableData1.forEach((item) => {
                    for (let i in this.ServiceList) {
                        if (item.idCode == this.ServiceList[i].personIdentity) {
                            this.$refs.multiapleTable.toggleRowSelection(
                                this.ServiceList[i],
                                true
                            )
                        }
                    }
                })
            })
            switch (title) {
                case "新增":
                    this.$forceUpdate()
                    this.getServiceList()
                    break
                case "查看":
                    this.look3(date)
                    break
                case "编辑":
                    this.look3(date)
                    break
            }
        },
        //table表格表单弹窗关闭时事件
        dialogVisibleClone() {
            this.formData.constructUnit = "" //建设单位
            this.formData.leader = "" //负责人
            this.formData.phone = "" //负责人手机
            this.formData.shengId = ""
            this.formData.shiId = ""
            this.formData.quId = ""
            this.formData.address = ""
            this.formData.id = ""
            this.formData.orgName = ""
            this.$refs.addformRef.resetFields()
        },

        //人员列表
        dialogVisibleClone1() {
            this.tableDataPageSize = 10
            this.tableDataPageNo = 1
        },

        //人员列表查看新增
        dialogVisibleClone2() {
            this.dialogVisible2 = false
            this.formData1.name = ""
            this.formData1.phone = ""
            this.formData1.idCode = ""
            this.$refs.multiapleTable.clearSelection()
        },

        clear1() {
            this.dialogVisible2 = false
            this.cneterList = []
            // this.serviceProviderPersonIds=[]
            //  this.$refs.multiapleTable.clearSelection()
        },
        clear2() {
            this.dialogVisible1 = false
            this.cneterList = []
            // this.serviceProviderPersonIds=[]
            this.$refs.multiapleTable.clearSelection()
        },
        async save1() {
            let arr = []
            this.cneterList.forEach((item) => {
                arr.push(item.id)
            })
            //   let obj = {}
            this.serviceProviderPersonIds = arr.reduce((cur, next) => {
                cur.indexOf(next) === -1 && cur.push(next)
                return cur
            }, [])
            let params = {
                serviceProviderId: this.workId,
                serviceProviderPersonIds: this.serviceProviderPersonIds,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/serviceProviderPersons/info/saveProcidePersons",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code == 200) {
                    this.look2(this.workId)
                    this.$message.success("保存成功")
                    this.dialogVisible = false
                    this.$refs.multiapleTable.clearSelection()
                } else {
                    this.$message.error("保存失败")
                }
                this.dialogVisible2 = false
                this.cneterList = []
                //
            })
        },
        save2() {
            this.dialogVisible1 = false
            this.$refs.multiapleTable.clearSelection()
        },

        //文件发生改变是触发
        handleAvatarSuccess(file, fileList) {
            this.imageUrl = URL.createObjectURL(file.raw)
        },
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG/PNG 格式!")
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
            }
            return isJPG && isLt2M
        },

        //根据输入地址转换经纬度并标记
        transLocation() {
            var searchKey = this.userform.homeAddress
            var map = new AMap.Map("container", {
                resizeEnable: true,
                zoom: 18,
            })
            var that = this
            AMap.plugin("AMap.Geocoder", function () {
                var geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all",
                })
                var marker = new AMap.Marker()
                geocoder.getLocation(searchKey, function (status, result) {
                    if (status === "complete" && result.geocodes.length) {
                        var lnglat = result.geocodes[0].location
                        // that.userform.longitude = Number(lnglat.lng);
                        // that.userform.latitude = Number(lnglat.lat);
                        marker.setPosition(lnglat)
                        map.add(marker)
                        map.setFitView(marker)
                    } else {
                        that.$message({
                            message: "获取坐标失败，请手动获取",
                            type: "error",
                        })
                    }
                })
            })
            var geocoder = new AMap.Geocoder({
                city: "010", //城市设为北京，默认：“全国”
                radius: 1000, //范围，默认：500
            })
            map.on("click", function (e) {
                // that.userform.longitude = Number(e.lnglat.getLng());
                // that.userform.latitude = Number(e.lnglat.getLat());
                geocoder.getAddress(
                    e.lnglat.getLng() + "," + e.lnglat.getLat(),
                    function (status, result) {
                        if (status === "complete" && result.regeocode) {
                            var address = result.regeocode.formattedAddress
                            // that.form.homeAddress = address;
                            that.$set(that.userform, "homeAddress", address)
                        } else {
                            log.error("根据经纬度查询地址失败")
                        }
                    }
                )
            })
        },

        async handleDetaiClick(date) {
            this.detailListDialogVisible = true
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/settlementManage/info/geteElderlySubProManage",
                method: "POST",
                data: params,
            }).then((res) => {
                this.detailListtableData = res.content
            })
        },
        deleteId(date) {
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/serviceProvider/info/deleteById",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    if ((res.code = 200)) {
                        this.$message.success("删除成功")
                        this.showList()
                    }
                })
            })
        },
        deletePersonId(date) {
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/serviceProviderPersons/info/deleteById",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    if ((res.code = 200)) {
                        this.$message.success("删除成功")
                        this.look2(date)
                    }
                })
            })
        },
        //列表pagesize发生改变
        handletableSize(val) {
            this.pageSize = val
            this.showList()
        },
        //列表页码发生改变
        handleTableChange(val) {
            this.pageNo = val
            this.showList()
        },
        //列表pagesize发生改变
        handleTableDataPageSize(val) {
            this.tableDataPageSize = val
            this.look2(this.workId)
        },
        //列表页码发生改变
        handleTableDataChange(val) {
            this.tableDataPageNo = val
            this.look2(this.workId)
        },
        //列表pagesize发生改变
        handleTableData1PageSize(val) {
            this.tableData1PageSize = val
            this.getServiceList()
        },
        //列表页码发生改变
        handleTableData1Change(val) {
            this.tableData1PageNo = val
            this.getServiceList()
        },
        async showList(s) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                leader: this.leader,
                phone: this.phone,
                constructUnit: s === true ? "" : this.constructUnit,
                orgId: JSON.parse(localStorage.getItem("czUserInfo")).orgId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/serviceProvider/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code == 200) {
                    this.tableData = res.content.list
                    this.total = res.content.count
                    if (res.content == null || res.content == "null") {
                        this.tableData = []
                        this.total = 0
                    }
                }
            })
        },
        async search() {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                leader: this.leader,
                phone: this.phone,
                constructUnit: this.constructUnit,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/serviceProvider/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.content != null) {
                    this.tableData = res.content.list
                    this.total = res.content.count
                } else {
                    this.tableData = []
                    this.total = 0
                }
            })
        },
        getCommon(val) {},
        save() {
            if (
                this.formData.constructUnit === "" ||
                this.formData.constructUnit === null
            ) {
                this.$message.error("建设单位不能为空")
                return
            }
            if (this.formData.leader === "" || this.formData.leader === null) {
                this.$message.error("负责人不能为空")
                return
            }
            if (this.formData.phone === "" || this.formData.phone === null) {
                this.$message.error("负责人手机号不能为空")
                return
            }
            // if (!chekPhone(this.formData.phone)) {
            //     this.$message.error("手机号格式错误")
            //     return
            // }
            if (
                this.formData.shengId === "" ||
                this.formData.shengId === null
            ) {
                this.$message.error("省级地址不能为空")
                return
            }
            if (this.formData.shiId === "" || this.formData.shiId === null) {
                this.$message.error("市级地址不能为空")
                return
            }
            if (this.formData.quId === "" || this.formData.quId === null) {
                this.$message.error("县级地址不能为空")
                return
            }
            if (
                this.formData.address === "" ||
                this.formData.address === null
            ) {
                this.$message.error("详细地址不能为空")
                return
            }
            this.isdisabled = true
            let obj = common.organization(
                this.arrOrgList,
                this.normalInfo.orgLevel
            )
            let params = {
                ...this.formData,
                qujiId: obj.qujiId,
                shengjiId: obj.shengjiId,
                shijiId: obj.shijiId,
                stationId: obj.stationId,
                shequjiId: obj.shequjiId,
            }
            params = Object.assign({}, params)

            request({
                url: "/jjyl/admin/serviceProvider/info/insertOrUpdate",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code == 200) {
                    this.$message.success("保存成功")
                    this.dialogVisible = false
                    this.showList()
                } else {
                    this.$message.error("保存失败")
                }
            })
        },
        look(date) {
            let self = this
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            request({
                url: "/jjyl/admin/serviceProvider/info/getById",
                method: "POST",
                data: params,
            }).then(async (res) => {
                // this.formData.constructUnit = "" //建设单位
                // this.formData.leader = "" //负责人
                // this.formData.phone = "" //负责人手机
                // this.formData.shengId = ''
                // this.formData.shiId = ''
                // this.formData.quId = ''
                // this.formData.address = ''
                // console.log(res)

                this.formData = res.content
                this.formData.dataName = this.setDataName(
                    this.orgList,
                    res.content.dataId
                )
                this.formData.costDetail = res.content.elderlyInformationList
                let jsonTemp = { ...this.formData }
                this.formData.streetId = String(jsonTemp.streetId)
                this.formData.shequId = Number(jsonTemp.shequId)
                if (
                    self.dialogVisibleTitle == "查看" ||
                    self.dialogVisibleTitle == "编辑"
                ) {
                    if (self.formData.shengId) {
                        let city = await self.getDistrict(self.formData.shengId)
                        self.cityList = city.districtList
                    }
                    if (self.formData.shiId) {
                        let area = await self.getDistrict(self.formData.shiId)
                        self.areaList = area.districtList
                    }
                    if (self.formData.quId) {
                        // let street = await self.getDistrict(self.formData.quId)
                        //  self.streetList = street.districtList
                        let streetList = await self.getStreetList(
                            self.formData.quId
                        )
                        self.streetList = streetList
                    }
                    if (self.formData.streetId) {
                        let communityList = await self.getCommityList(
                            self.formData.streetId
                        )
                        self.communityList = communityList
                    }
                    setTimeout(async () => {
                        await self.$nextTick(() => {
                            self.loadmap("container")
                            self.potintMap()
                        })
                    }, 30)
                    this.$forceUpdate()
                }
            })
        },

        look4(date) {
            let params = {
                serviceProviderId: date.serviceProviderId,
                pageNo: this.tableDataPageNo,
                pageSize: this.tableDataPageSize,
            }
            params = Object.assign({}, params)
            request({
                url: "/jjyl/admin/serviceProviderPerson/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        this.tableData1 = []
                        this.tableDataTotal = 0
                        return
                    }
                    this.tableData1 = res.content.list
                    this.tableDataTotal = res.content.count
                }
            })
        },

        async look2(date) {
            this.tableData1 = []
            let params = {
                serviceProviderId: this.workId,
                pageNo: this.tableDataPageNo,
                pageSize: this.tableDataPageSize,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/serviceProviderPersons/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        this.tableData1 = []
                        this.tableDataTotal = 0
                        return
                    }
                    this.tableData1 = res.content.list
                    this.tableDataTotal = res.content.count
                }
            })
        },

        reset() {
            this.leader = ""
            this.phone = ""
            this.constructUnit = ""
            this.pageSize = 10
            this.pageNo = 1
            this.showList()
        },
    },
    created() {
        this.baseUrl =
            baseURL + "/jjyl/controller/uploadController/info/uploadPhoto"
        this.getProvince()
        this.showList()
        this.getOrg()
        // this.getchangeList()
    },
    mounted() {},
}
</script>

<style lang="less" scoped>
.settlement_container {
    .table_container {
        width: 100%;
        margin-top: 48px;
    }
}
.dialog-footer {
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>